import { FlowStateController } from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";

import {
    BackgroundEvents,
    EventsManager,
    FlowEvents,
    GameEvents,
    ReelsEvents,
} from "../../../abstracts/events/EventsManager";
import { AbstractFlowPresentation } from "../../../abstracts/flow/AbstractFlowStatePresentation";
import { AbstractGameMode } from "../../../abstracts/flow/AbstractGameMode";
// import { log } from "../../../abstracts/utils/AbstractConsole";
import { shuffleArray } from "../../../abstracts/utils/ArrayUtils";
import { playSound } from "../../../abstracts/utils/SoundUtils";
import { ApocalypseSoundNames } from "../../assetsLoader/ApocalypseAssetsNames";
import { normalConfig } from "../../config/ApocalypseConfig";
import { REMOVE_FAKE_SCATTERS } from "../../events/ApocalypseEvents";
import { ApocalypseBackgroundView } from "../../modules/Background/ApocalypseBackgroundView";
import { ApocalypseReelsView } from "../../modules/Reels/ApocalypseReelsView";
import ApocalypseReel, { reelLandSounds } from "../../modules/Reels/normal/ApocalypseReel";
import { IApocalypseReelAnimation } from "../../types/ApocalypseInterfaces";

export class ApocalypseNormalBetPresentation extends AbstractFlowPresentation {
    protected reelsView: ApocalypseReelsView;
    protected backgroundView: ApocalypseBackgroundView;

    protected reels: ApocalypseReel[] = [];

    constructor(protected id: string = `ApocalypseNormalBetPresentation`) {
        super(id);
    }

    protected handleEvents(): void {
        super.handleEvents();

        EventsManager.on(ReelsEvents.GET_NORMAL_REELS, (normalReels: ApocalypseReel[]) => {
            this.reels = normalReels;
        });

        EventsManager.on(FlowEvents.SKIP_NORMAL_BET, () => {
            this.flowPresentationTimeline?.timeScale(this.config.skipCurrentSymbolsTimeScale!);
        });

        EventsManager.on(ReelsEvents.GET_REELS_VIEW, (reelsView: ApocalypseReelsView) => {
            this.reelsView = reelsView;
        });

        EventsManager.on(
            BackgroundEvents.GET_BACKGROUND_VIEW,
            (backgroundView: ApocalypseBackgroundView) => {
                this.backgroundView = backgroundView;
            }
        );
    }

    protected get config(): IApocalypseReelAnimation {
        return normalConfig;
    }

    public start(flowStateController: FlowStateController) {
        super.start(flowStateController);

        shuffleArray(reelLandSounds);

        let shoudPlayCloseBlockerSound: boolean = false;

        let reelCounter: number = 0;
        this.reels.forEach((reel) => {
            if (!reel.isLocked) {
                reelCounter++;
            }
            const reelTimingIndex = reel.isLocked ? 0 : reelCounter;

            this.flowPresentationTimeline.call(() => reel.resetOnStartSpin(), undefined, 0);
            this.flowPresentationTimeline.add(
                reel.startNormalBetAnimation(),
                this.config.startMinDelay! + this.config.startReelsDelay! * reelTimingIndex
            );
        });

        if (shoudPlayCloseBlockerSound) {
            this.flowPresentationTimeline.call(
                () => {
                    // playSound({ name: ApocalypseSoundNames.BLOCKER_CLOSE });
                },
                undefined,
                0
            );
        }

        this.flowPresentationTimeline.resume();

        EventsManager.trigger(GameEvents.DISABLE_IDLE_ANIMATIONS);

        playSound({ name: ApocalypseSoundNames.REELS_SPIN });
    }

    protected onBetStarted(): void {
        EventsManager.trigger(FlowEvents.BET_STARTED);
        this.reelsView.disableIdle();

        if (this.model.data.nextMode === AbstractGameMode.NORMAL) {
            EventsManager.trigger(REMOVE_FAKE_SCATTERS);
        }
    }
}
